import React from 'react'
import './Footer.css'

const Footer = () => {
  return (
    <div className='footer'>
        <p>© 2024 4klabs. All Rights Reserved.</p>
        <ul>
            <li>Terms of Serices</li>
            <li>Privacy Policy</li>
        </ul>
    </div>
  )
}

export default Footer